export default "__VITE_ASSET__DaCqyE30__"